module.exports = __webpack_public_path__ + "static/media/check-active.13349b2f.svg";